<template>
<div>
    <Breadcrumbs main="CRM" title="Opportunities" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <!-- Summary Widgets -->
                        <div class="row">
                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 mt-4 mt-md-2 mt-lg-4 mt-xl-0">
                                <router-link to="/project/my-project">
                                    <div class="card small-widget">
                                        <div class="card-body success"><span class="f-light">Open Pipeline</span>
                                            <div class="d-flex align-items-end gap-1">
                                                <h4>৳ {{ totalValue.toLocaleString() }}</h4>
                                            </div>
                                            <div class="bg-gradient">
                                                <svg class="stroke-icon svg-fill" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">
                                                    <g id="SVGRepo_iconCarrier">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.25 6C3.25 4.45831 4.48029 3.26447 6.00774 2.50075C7.58004 1.7146 9.69967 1.25 12 1.25C14.3003 1.25 16.42 1.7146 17.9923 2.50075C19.5197 3.26447 20.75 4.45831 20.75 6V18C20.75 19.5417 19.5197 20.7355 17.9923 21.4992C16.42 22.2854 14.3003 22.75 12 22.75C9.69967 22.75 7.58004 22.2854 6.00774 21.4992C4.48029 20.7355 3.25 19.5417 3.25 18V6ZM4.75 6C4.75 5.33255 5.31057 4.52639 6.67856 3.84239C8.00168 3.18083 9.88205 2.75 12 2.75C14.118 2.75 15.9983 3.18083 17.3214 3.84239C18.6894 4.52639 19.25 5.33255 19.25 6C19.25 6.66745 18.6894 7.47361 17.3214 8.15761C15.9983 8.81917 14.118 9.25 12 9.25C9.88205 9.25 8.00168 8.81917 6.67856 8.15761C5.31057 7.47361 4.75 6.66745 4.75 6ZM4.75 18C4.75 18.6674 5.31057 19.4736 6.67856 20.1576C8.00168 20.8192 9.88205 21.25 12 21.25C14.118 21.25 15.9983 20.8192 17.3214 20.1576C18.6894 19.4736 19.25 18.6674 19.25 18V14.7072C18.8733 15.0077 18.4459 15.2724 17.9923 15.4992C16.42 16.2854 14.3003 16.75 12 16.75C9.69967 16.75 7.58004 16.2854 6.00774 15.4992C5.55414 15.2724 5.12675 15.0077 4.75 14.7072V18ZM19.25 8.70722V12C19.25 12.6674 18.6894 13.4736 17.3214 14.1576C15.9983 14.8192 14.118 15.25 12 15.25C9.88205 15.25 8.00168 14.8192 6.67856 14.1576C5.31057 13.4736 4.75 12.6674 4.75 12V8.70722C5.12675 9.00772 5.55414 9.27245 6.00774 9.49925C7.58004 10.2854 9.69967 10.75 12 10.75C14.3003 10.75 16.42 10.2854 17.9923 9.49925C18.4459 9.27245 18.8733 9.00772 19.25 8.70722Z"></path>
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>

                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 mt-4 mt-md-2 mt-lg-4 mt-xl-0">
                                <router-link to="/my-workspace/ticket/raise-a-ticket">
                                    <div class="card small-widget">
                                        <div class="card-body success"><span class="f-light">Qualified Deals</span>
                                            <div class="d-flex align-items-end gap-1">
                                                <h4>{{ opportunities?.qualified?.count ?? 0 }}</h4>
                                            </div>
                                            <div class="bg-gradient">
                                                <svg class="stroke-icon svg-fill" height="30px" width="30px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000">
                                                    <g id="SVGRepo_iconCarrier">
                                                        <g>
                                                            <path class="st0 fill-danger" d="M92.574,294.24V124.336H43.277C19.449,124.336,0,144.213,0,168.467v206.44 c0,24.254,19.449,44.133,43.277,44.133h62v45.469c0,3.041,1.824,5.777,4.559,6.932c2.736,1.154,5.957,0.486,8.023-1.641 l49.844-50.76h106.494c23.828,0,43.279-19.879,43.279-44.133v-0.061H172.262C128.314,374.846,92.574,338.676,92.574,294.24z"></path>
                                                            <path class="st0 fill-success" d="M462.717,40H172.26c-27.105,0-49.283,22.59-49.283,50.197v204.037c0,27.61,22.178,50.199,49.283,50.199 h164.668l75.348,76.033c2.399,2.442,6.004,3.172,9.135,1.852c3.133-1.322,5.176-4.434,5.176-7.887v-69.998h36.131 c27.106,0,49.283-22.59,49.283-50.199V90.197C512,62.59,489.822,40,462.717,40z M369.156,280.115H195.92v-24.316h173.236V280.115z M439.058,204.129H195.92v-24.314h243.138V204.129z M439.058,128.143H195.92v-24.315h243.138V128.143z"></path>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>

                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 mt-4 mt-md-2 mt-lg-4 mt-xl-0">
                                <router-link to="/project/my-project">
                                    <div class="card small-widget">
                                        <div class="card-body success"><span class="f-light">Avg. Age</span>
                                            <div class="d-flex align-items-end gap-1">
                                                <h4>15d</h4>
                                            </div>
                                            <div class="bg-gradient">
                                                <svg class="stroke-icon svg-fill" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">
                                                    <g id="SVGRepo_iconCarrier">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.25 6C3.25 4.45831 4.48029 3.26447 6.00774 2.50075C7.58004 1.7146 9.69967 1.25 12 1.25C14.3003 1.25 16.42 1.7146 17.9923 2.50075C19.5197 3.26447 20.75 4.45831 20.75 6V18C20.75 19.5417 19.5197 20.7355 17.9923 21.4992C16.42 22.2854 14.3003 22.75 12 22.75C9.69967 22.75 7.58004 22.2854 6.00774 21.4992C4.48029 20.7355 3.25 19.5417 3.25 18V6ZM4.75 6C4.75 5.33255 5.31057 4.52639 6.67856 3.84239C8.00168 3.18083 9.88205 2.75 12 2.75C14.118 2.75 15.9983 3.18083 17.3214 3.84239C18.6894 4.52639 19.25 5.33255 19.25 6C19.25 6.66745 18.6894 7.47361 17.3214 8.15761C15.9983 8.81917 14.118 9.25 12 9.25C9.88205 9.25 8.00168 8.81917 6.67856 8.15761C5.31057 7.47361 4.75 6.66745 4.75 6ZM4.75 18C4.75 18.6674 5.31057 19.4736 6.67856 20.1576C8.00168 20.8192 9.88205 21.25 12 21.25C14.118 21.25 15.9983 20.8192 17.3214 20.1576C18.6894 19.4736 19.25 18.6674 19.25 18V14.7072C18.8733 15.0077 18.4459 15.2724 17.9923 15.4992C16.42 16.2854 14.3003 16.75 12 16.75C9.69967 16.75 7.58004 16.2854 6.00774 15.4992C5.55414 15.2724 5.12675 15.0077 4.75 14.7072V18ZM19.25 8.70722V12C19.25 12.6674 18.6894 13.4736 17.3214 14.1576C15.9983 14.8192 14.118 15.25 12 15.25C9.88205 15.25 8.00168 14.8192 6.67856 14.1576C5.31057 13.4736 4.75 12.6674 4.75 12V8.70722C5.12675 9.00772 5.55414 9.27245 6.00774 9.49925C7.58004 10.2854 9.69967 10.75 12 10.75C14.3003 10.75 16.42 10.2854 17.9923 9.49925C18.4459 9.27245 18.8733 9.00772 19.25 8.70722Z"></path>
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>

                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 mt-4 mt-md-2 mt-lg-4 mt-xl-0">
                                <router-link to="/my-workspace/ticket/raise-a-ticket">
                                    <div class="card small-widget">
                                        <div class="card-body success"><span class="f-light">Stale Deals</span>
                                            <div class="d-flex align-items-end gap-1">
                                                <h4>8</h4>
                                            </div>
                                            <div class="bg-gradient">
                                                <svg class="stroke-icon svg-fill" height="30px" width="30px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000">
                                                    <g id="SVGRepo_iconCarrier">
                                                        <g>
                                                            <path class="st0 fill-danger" d="M92.574,294.24V124.336H43.277C19.449,124.336,0,144.213,0,168.467v206.44 c0,24.254,19.449,44.133,43.277,44.133h62v45.469c0,3.041,1.824,5.777,4.559,6.932c2.736,1.154,5.957,0.486,8.023-1.641 l49.844-50.76h106.494c23.828,0,43.279-19.879,43.279-44.133v-0.061H172.262C128.314,374.846,92.574,338.676,92.574,294.24z"></path>
                                                            <path class="st0 fill-success" d="M462.717,40H172.26c-27.105,0-49.283,22.59-49.283,50.197v204.037c0,27.61,22.178,50.199,49.283,50.199 h164.668l75.348,76.033c2.399,2.442,6.004,3.172,9.135,1.852c3.133-1.322,5.176-4.434,5.176-7.887v-69.998h36.131 c27.106,0,49.283-22.59,49.283-50.199V90.197C512,62.59,489.822,40,462.717,40z M369.156,280.115H195.92v-24.316h173.236V280.115z M439.058,204.129H195.92v-24.314h243.138V204.129z M439.058,128.143H195.92v-24.315h243.138V128.143z"></path>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>

                        <!-- Kanban Board -->
                        <div class="kanban-board mt-4" v-if="opportunities">
                            <div
                                v-for="stage in stages"
                                :key="stage.key"
                                class="kanban-col"
                                :class="`stage-${stage.key}`"
                            >
                                <!-- Column Header -->
                                <div class="kanban-col-header">
                                    <div class="d-flex align-items-center gap-2">
                                        <span class="stage-dot"></span>
                                        <span class="stage-label ml-2">{{ stage.label }}</span>
                                    </div>
                                    <span class="badge stage-badge">{{ stage.count }}</span>
                                </div>

                                <!-- Cards -->
                                <div class="kanban-col-body">
                                    <div v-if="stage.leads.length === 0" class="kanban-empty">
                                        No leads
                                    </div>
                                    <div
                                        v-for="(lead, i) in stage.leads"
                                        :key="lead.id"
                                        class="kanban-card"
                                        :style="{ animationDelay: i * 0.07 + 's' }"
                                    >
                                        <router-link :to="`/crm/lead/details/${lead.id}`" class="text-decoration-none">
                                            <div class="kanban-card-accent"></div>
                                            <div class="d-flex justify-content-between align-items-start mb-1">
                                                <span class="lead-name">{{ formatName(lead.lead_name) }}</span>
                                                <!-- <span class="lead-id">#{{ lead.id }}</span> -->
                                            </div>
                                            <div class="lead-company">
                                                <i v-if="lead.company_name">{{ lead.company_name }}</i>
                                                <i v-else class="text-muted">No company</i>
                                            </div>
                                            <div v-if="lead.next_action" class="lead-action mt-1">
                                                → {{ lead.next_action }}
                                            </div>
                                            <div class="d-flex justify-content-between align-items-center kanban-card-footer">
                                                <span class="lead-value">৳{{ (lead.pipeline_value || 0).toLocaleString() }}</span>
                                                <span class="badge bg-success-subtle text-success lead-status">{{ lead.status }}</span>
                                            </div>
                                        </router-link>
                                    </div>
                                </div>

                                <!-- Column Footer -->
                                <div class="kanban-col-footer">
                                    Total: ৳{{ stage.total_value.toLocaleString() }}
                                </div>
                            </div>
                        </div>

                        <!-- Loading state -->
                        <div v-else class="text-center py-5 text-muted">
                            <div class="spinner-border spinner-border-sm me-2"></div>
                            Loading pipeline...
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import { mapState } from 'vuex';

const STAGE_ORDER  = ['qualified', 'discovery', 'demo', 'proposal', 'trial'];
const STAGE_LABELS = {
    qualified: 'Qualified',
    discovery: 'Discovery',
    demo:      'Demo',
    proposal:  'Proposal',
    trial:     'Trial',
};

export default {
    data() {
        return {};
    },

    computed: {
        ...mapState({
            opportunities: state => state.client.opportunities
        }),

        stages() {
            if (!this.opportunities) return [];
            return STAGE_ORDER.map(key => ({
                key,
                label: STAGE_LABELS[key],
                ...(this.opportunities[key] || { count: 0, total_value: 0, leads: [] }),
            }));
        },

        totalValue() {
            if (!this.opportunities) return 0;
            return STAGE_ORDER.reduce((sum, key) => sum + (this.opportunities[key]?.total_value || 0), 0);
        },
    },

    mounted() {
        this.$store.dispatch('client/fetchOpportunityKanban');
    },

    methods: {
        formatName(raw) {
            if (!raw) return 'Unnamed Lead';
            return raw.replace(/\s+None\s*$/i, '').trim() || 'Unnamed Lead';
        },
    },
};
</script>

<style scoped>
* { box-sizing: border-box; }

/* ── Existing widget styles (unchanged) ─────────────────────────────────── */
.small-widget { overflow: hidden; }
.warning .bg-gradient  { background-image: linear-gradient(144.16deg, rgba(255,170,5,.1) 19.06%, rgba(255,170,5,0) 79.03%) !important; }
.success .bg-gradient  { background-image: linear-gradient(144.16deg, rgba(84,186,74,.1) 19.06%, rgba(84,186,74,0) 79.03%) !important; }
.secondary .bg-gradient{ background-image: linear-gradient(144.16deg, rgba(255,51,100,.1) 19.06%, rgba(255,51,100,0) 79.03%) !important; }
.secondary .svg-fill   { fill: #F73A6A; }
.success .svg-fill     { fill: #54ba4a; }
.warning .svg-fill     { fill: #ffaa05; }
.primary .svg-fill     { fill: #7366ff; }
.small-widget .bg-profile    { width:125px; height:130px; display:flex; align-items:center; justify-content:center; border-radius:100px; left:-12px; top:50%; position:absolute; transform:translateY(-50%); }
.small-widget .profile-info  { display:flex; flex-direction:column; top:50%; position:absolute; transform:translateY(-50%); }
.small-widget .bg-gradient   { width:66px; height:67px; display:flex; align-items:center; justify-content:center; border-radius:100px; right:-12px; top:50%; position:absolute; transform:translateY(-50%); }

/* ── Kanban board ────────────────────────────────────────────────────────── */
.kanban-board {
    display: flex;
    gap: 1rem;
    overflow-x: auto;
    padding-bottom: 1rem;
    align-items: flex-start;
}

.kanban-col {
    flex: 0 0 286px;
    background: var(--bs-body-bg, #f8f9fa);
    border: 1px solid var(--bs-border-color, #dee2e6);
    border-radius: 12px;
    overflow: hidden;
}

/* ── Column header ───────────────────────────────────────────────────────── */
.kanban-col-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.65rem 0.875rem;
    border-bottom: 1px solid var(--bs-border-color, #dee2e6);
}
.stage-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
}
.stage-label {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
}
.stage-badge {
    font-size: 0.8rem;
    padding: 4px 10px;
    border-radius: 20px;
    background: var(--bs-secondary-bg, #bebfc050);
    color: var(--bs-secondary-color, #3d4347);
    font-weight: 600;
}

/* ── Per-stage colors ────────────────────────────────────────────────────── */
/* qualified — blue */
.stage-qualified .kanban-col-header { background: rgba(59, 131, 246, 0.116); }
.stage-qualified .stage-dot         { background: #3b82f6; box-shadow: 0 0 5px #3b82f6; }
.stage-qualified .stage-label       { color: #3b82f6; }
.stage-qualified .kanban-card-accent{ background: #3b82f6; }
 
/* discovery — purple */
.stage-discovery .kanban-col-header { background: rgba(139,92,246,0.08); }
.stage-discovery .stage-dot         { background: #8b5cf6; box-shadow: 0 0 5px #8b5cf6; }
.stage-discovery .stage-label       { color: #8b5cf6; }
.stage-discovery .kanban-card-accent{ background: #8b5cf6; }
 
/* demo — #cffafe */
.stage-demo .kanban-col-header      { background: rgba(207, 250, 254, 0.404); }
.stage-demo .stage-dot              { background: #02e8fd; box-shadow: 0 0 5px #02e8fd; }
.stage-demo .stage-label            { color: #02e8fd; }
.stage-demo .kanban-card-accent     { background: #02e8fd; }
 
/* proposal — orange */
.stage-proposal .kanban-col-header  { background: rgba(249,115,22,0.08); }
.stage-proposal .stage-dot          { background: #f97316; box-shadow: 0 0 5px #f97316; }
.stage-proposal .stage-label        { color: #f97316; }
.stage-proposal .kanban-card-accent { background: #f97316; }
 
/* trial — rose (unchanged) */
.stage-trial .kanban-col-header     { background: rgba(251,113,133,0.08); }
.stage-trial .stage-dot             { background: #fb7185; box-shadow: 0 0 5px #fb7185; }
.stage-trial .stage-label           { color: #fb7185; }
.stage-trial .kanban-card-accent    { background: #fb7185; }

/* ── Column body ─────────────────────────────────────────────────────────── */
.kanban-col-body {
    padding: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-height: 60px;
}

/* ── Card ────────────────────────────────────────────────────────────────── */
.kanban-card {
    background: #fff;
    border: 1px solid var(--bs-border-color, #dee2e6);
    border-radius: 8px;
    padding: 0.7rem 0.75rem 0.6rem;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    animation: cardIn 0.25s ease both;
    position: relative;
    overflow: hidden;
}
.kanban-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0,0,0,0.1);
}

@keyframes cardIn {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
}

.kanban-card-accent {
    height: 3px;
    border-radius: 2px;
    margin-bottom: 0.55rem;
}

.lead-name {
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--bs-body-color, #212529);
    line-height: 1.3;
    word-break: break-word;
}
.lead-id {
    font-size: 0.65rem;
    color: var(--bs-secondary-color, #6c757d);
    white-space: nowrap;
    margin-left: 4px;
    margin-top: 1px;
}
.lead-company {
    font-size: 0.7rem;
    color: var(--bs-secondary-color, #6c757d);
    margin-bottom: 0.2rem;
}
.lead-action {
    font-size: 0.68rem;
    color: var(--bs-secondary-color, #6c757d);
}
.kanban-card-footer {
    margin-top: 0.5rem;
    padding-top: 0.4rem;
    border-top: 1px solid var(--bs-border-color, #dee2e6);
}
.lead-value {
    font-size: 0.7rem;
    color: var(--bs-secondary-color, #6c757d);
    font-weight: 500;
}
.lead-status {
    font-size: 0.6rem;
    padding: 2px 6px;
}

/* ── Column footer ───────────────────────────────────────────────────────── */
.kanban-col-footer {
    padding: 0.4rem 0.875rem 0.55rem;
    font-size: 0.68rem;
    color: var(--bs-secondary-color, #6c757d);
    border-top: 1px solid var(--bs-border-color, #dee2e6);
}

/* ── Empty state ─────────────────────────────────────────────────────────── */
.kanban-empty {
    text-align: center;
    padding: 1.25rem 0;
    font-size: 0.72rem;
    color: var(--bs-secondary-color, #6c757d);
    font-style: italic;
}
</style>